import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import pathConstant from "../../../utils/path.constant";

export default function LogoutPage() {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate(pathConstant.SIGNIN);
        }, 5000);

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className='flex flex-col gap-5 justify-center items-center h-screen w-full text-gray-600 bg-gray-200'>
            <div className='flex gap-2 justify-center items-center text-4xl'>
                <FontAwesomeIcon icon={faSpinner} className='animate-spin' />
                <p>Login session has expired or cleared. Redirecting to login page...</p>
            </div>
        </div>
    );
}
